import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from "../../app.component";
import {NavigationEnd, Router} from "@angular/router";
import {DataEndStats} from "../../const/mock-data";
import {AuthGuard} from "../../helpers/auth-guard.helper";
import {Subject, takeUntil} from "rxjs";
import { SanitizationHelper } from 'src/app/helpers/sanitization.helper';

@Component({
  selector: 'app-module-end',
  templateUrl: './module-end.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./module-end.component.less']
})
export class ModuleEndComponent implements OnInit, OnDestroy {
  global_texts: any = null;
  note: number = 0;
  stats_texts: any = null;
  has_stars: boolean = false;
  stars: number[] = Array(5).fill(0);
  current_screen_annexes: string[] | null = null;
  current_screen_special_class: string = '';
  private unsubscribe$ = new Subject<void>();

  constructor(
    public app: AppComponent,
    private router: Router,
    private authGuard: AuthGuard,
    private sanitizationHelper: SanitizationHelper
  ) {
    // Subscribe to router events
    //this.router.events.subscribe((event) => {
    this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log("NavigationEnd event END => ", event);
        this.initializeComponentEnd();
      }
    });
  }


  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit(): void {
    this.initializeComponentEnd();
  }

  initializeComponentEnd(): void {
    // Verify if the logout button was clicked
    if (this.authGuard.isLogoutClicked) {
      return;
    }

    // Reset the data
    this.current_screen_special_class = '';
    this.current_screen_annexes = null;

    // Get the global texts
    this.app.sharedHelper.getGlobalTexts().subscribe((texts: any) => {
      this.global_texts = texts;

      this.current_screen_annexes = this.app.sharedHelper.getCurrentScreenParam('annexes');
      this.current_screen_special_class = this.app.sharedHelper.getCurrentScreenParam('special_class');
      this.getNote();
    });
  }


  async getNote(): Promise<void> {
    // Get uuid module
    let uuid_module = this.app.sharedHelper.getModuleUuidFromUrl();
    this.note = await this.getScore(uuid_module);

    console.log("uuid_module ", uuid_module);

    // Get the text from export const DataEndStats switch note by ref in url
    let ref = this.app.sharedHelper.getRefPageFromUrl();
    let obj = this.getTextForNoteByRef(ref);

    let note_min = (uuid_module === "f3ea5105-1688-4b2c-a062-691924de46aa") ? 5 : 4;

    if (obj) {
      //obj = this.sanitizationHelper.sanitizeObject(obj);
      // Get true or false has stars
      this.has_stars = obj.has_stars_note;
      // Get the textes
      this.stats_texts = (this.note < note_min) ? this.sanitizationHelper.sanitizeObject(obj.is_not_correct) : this.sanitizationHelper.sanitizeObject(obj.is_correct);

      console.log("this.stats_texts ==> ", this.stats_texts);
    }
  }

  async getScore(_uuid_module:string): Promise<number> {
    try {
      const response: any = await this.app.apiService.getScore(_uuid_module).toPromise();
      console.log("response => ", response);
      return response.data;
    } catch (error) {
      console.log("error => ", error);
      return 0;
    }
  }

  getTextForNoteByRef(_ref: string): any {
    return DataEndStats.find((r: any) => r.ref === _ref);
  }
}
